import { Action } from '@ngrx/store';

export enum QuickSearchActionTypes {
  SearchDossiersBySearchTerm = '[QuickSearch] Search Dossiers By Search Term',
  SetSearchTerm = '[QuickSearch] Set Search Term'
}

export class SetSearchTerm implements Action {
  readonly type = QuickSearchActionTypes.SetSearchTerm;
  constructor(public payload: string) {}
}

export class SearchDossiersBySearchTerm implements Action {
  readonly type = QuickSearchActionTypes.SearchDossiersBySearchTerm;
}

export type QuickSearchDossiersActions =
  | SetSearchTerm
  | SearchDossiersBySearchTerm;
